import GhostImage from "../assets/images/sad-ghost.png"; 
import GhostHandsUpImage from "../assets/images/sad-ghost-hands-up.png";
import { useEffect, useRef, useState } from "react";

//게시글 없을 때 출력할 유령
export default function NoResult({ listData }) {
  const [isHovering, setIsHovering] = useState(false);
  const [ghostOffset, setGhostOffset] = useState({ x: 0, y: 0 });
  const containerRef = useRef(null);

  useEffect(() => {
    const handleMouseMove = (e) => {
      if (!containerRef.current) return;

      const rect = containerRef.current.getBoundingClientRect();
      const centerX = rect.left + rect.width / 2;
      const centerY = rect.top + rect.height / 2;

      const dx = e.clientX - centerX;
      const dy = e.clientY - centerY;

      const maxMove = 30; // 유령이 더 많이 움직이게 할 값
      const distance = Math.sqrt(dx * dx + dy * dy);
      const ratio = Math.min(maxMove / distance, 1);

      setGhostOffset({
        x: dx * ratio,
        y: dy * ratio,
      });
    };

    window.addEventListener("mousemove", handleMouseMove);
    return () => window.removeEventListener("mousemove", handleMouseMove);
  }, []);

  return (
    <div
      ref={containerRef}
      style={{
        position: "relative",
        width: "100%",
        height: "100%",
        overflow: "hidden",
      }}
      onMouseEnter={() => setIsHovering(true)} 
      onMouseLeave={() => setIsHovering(false)}
    >
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          height: "100%",
        }}
      >
        <img
          src={isHovering ? GhostHandsUpImage : GhostImage}
          alt="No Data"
          style={{
            width: "300px",
            height: "300px",
            objectFit: "contain",
            transform: `translate(${ghostOffset.x}px, ${ghostOffset.y}px)`,
            transition: "transform 0.2s ease",
            pointerEvents: "none", // 이미지에는 여전히 막아야 함
          }}
        />
        <p style={{ color: "#6b7280", fontSize: "1.125rem", marginTop: "1rem" }}>
          데이터가 존재하지 않습니다!
        </p>
      </div>
    </div>
  );
}
